export default {
  tags: {
    default: 'Standard',
    visible_to: 'Synlig for',
    not_visible_to: 'Ikke synlig for',
  },
  labels: {
    inclusive: 'Inklusive',
    exclusive: 'Eksklusive',
    public: 'Offentlig',
  },
  buttons: {
    edit: 'Rediger',
    delete: 'Slet',
  },
};
